import { PreisBezeichnung } from 'fobclient/lib/entity'

import FieldsGeneric from './FieldsGeneric'
let Fields = FieldsGeneric('PreisBezeichnung')

export default {
  label: 'PreisBezeichnung',
  route: 'preisBezeichnung',
  class: PreisBezeichnung,
  className: 'preisBezeichnung',
  fields: [
    {
      ...Fields.String('name'),
      table: true
    },
    {
      ...Fields.String('beschreibung'),
      table: true
    }
  ]
}



// WEBPACK FOOTER //
// ./src/schema/PreisBezeichnung.js